import { createSlice } from "@reduxjs/toolkit";

const offlineQueueSlice = createSlice({
  name: "offlineQueue",
  initialState: {
    count: 0,
    queue: [],
    IsSyncOnGoing: false,
    refreshTransaction: false,
  },
  reducers: {
    addToQueue: (state, action) => {
      state.queue.push(action.payload);
      state.count = state.queue.length;
    },
    removeFromQueue: (state, action) => {
      state.queue = state.queue.filter((item) => item.queueID !== action.payload);
      state.count = state.queue.length;
    },
    emptyQueue: (state) => {
      state.queue = [];
      state.count = 0;
    },
    setIsSyncOnGoing: (state, action) => {
      state.IsSyncOnGoing = action.payload;
    },
    setRefreshTransaction: (state, action) => {
      state.refreshTransaction = action.payload;
    },
  },
});

// ✅ Export Actions
export const { addToQueue, removeFromQueue, emptyQueue, setIsSyncOnGoing, setRefreshTransaction } = offlineQueueSlice.actions;
// ✅ Export Reducer
export default offlineQueueSlice.reducer;
